import CloseIcon from '@mui/icons-material/Close';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import {
    Dialog,
    DialogContent,
    DialogContentText,
    Grid,
    Typography,
} from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import React from 'react';
import UserRole from '../../../../shared/AuthRoles';
import toast from '../../../shared/Toast';
import { CustomButton } from '../../../../layout/styledcomponents/CustomButton';
const { REACT_APP_BASE_URL } = process.env;

const ReservationCalendarModal = ({
    onClose,
    open,
    calendarId,
}: {
    onClose: any;
    open: any;
    calendarId: any;
}) => {
    const loggedInUser = UserRole();

    const guestUserCalendar = `${REACT_APP_BASE_URL}/calendar/guestUsers/${calendarId}.ics`;
    const guestCalendar = `${REACT_APP_BASE_URL}/calendar/guests/${calendarId}.ics`;

    async function copyTextToClipboard(url: string) {
        if ('clipboard' in navigator) {
            return await navigator.clipboard.writeText(url);
        } else {
            return document.execCommand('copy', true, url);
        }
    }

    const handleCalendarCopyClick = (calendarType: 'guestUser' | 'guest') => {
        const urlToCopy =
            calendarType === 'guestUser' ? guestUserCalendar : guestCalendar;

        copyTextToClipboard(urlToCopy)
            .then(() => {
                toast.success('Link copied to clipboard');
            })
            .catch((err) => {
                console.error('Failed to copy text:', err);
                toast.error('Failed to copy. Please try again.');
            });
    };

    const isAdmin = ['guest_department_admin', 'guest_admin'].includes(
        loggedInUser?.role,
    );

    return (
        <Dialog open={open}>
            <DialogTitle>
                Sync Your Calendar
                <IconButton
                    aria-label='close'
                    onClick={() => onClose()}
                    size='small'
                    sx={{ color: 'text.primary' }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent
                dividers
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: 'auto',
                }}
            >
                <DialogContentText
                    sx={{
                        display: 'flex',
                        width: '100%',
                        flexDirection: 'column',
                    }}
                >
                    <Typography
                        sx={{
                            marginBottom: '15px',
                        }}
                    >
                        You can use the link
                        {isAdmin && 's'} below to sync your reservations with an
                        external calendar such as Google Calendar or Outlook.
                    </Typography>
                    <Typography
                        sx={{
                            marginBottom: '25px',
                        }}
                    >
                        {isAdmin
                            ? 'These links provide a read-only view and are '
                            : 'This link provides a read-only view and is '}
                        refreshed based on the external calendar's update
                        frequency. Only approved and completed reservations are
                        included.
                    </Typography>

                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <CustomButton
                                variant='outlined'
                                color='primary'
                                sx={{
                                    width: '100%',
                                    height: '39px',
                                }}
                                startIcon={<ContentCopyIcon />}
                                onClick={() =>
                                    handleCalendarCopyClick('guestUser')
                                }
                            >
                                {isAdmin ? 'My Calendar Link' : ' Copy Link'}
                            </CustomButton>
                        </Grid>
                        {isAdmin && (
                            <Grid item xs={12}>
                                <CustomButton
                                    variant='outlined'
                                    color='primary'
                                    sx={{
                                        width: '100%',
                                        height: '39px',
                                    }}
                                    startIcon={<ContentCopyIcon />}
                                    onClick={() =>
                                        handleCalendarCopyClick('guest')
                                    }
                                >
                                    {' '}
                                    {loggedInUser?.role === 'guest_admin'
                                        ? 'Company '
                                        : `Department `}{' '}
                                    Calendar Link
                                </CustomButton>
                            </Grid>
                        )}
                    </Grid>
                </DialogContentText>
            </DialogContent>
        </Dialog>
    );
};

export default ReservationCalendarModal;
